/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

function FieldStaffDailyRosterGrid({ data }: { data: any[] }) {
  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "80px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Route No
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Duty Timings
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Fleet No
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Van Reg. No
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Site
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Driver
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Crew1
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Crew2
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Crew3
            </th>

            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Nationality Count
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((req: any, i: number) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={i}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {req.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.routeNo}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.dutyTimings}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.fleetNo}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.registrationNo}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.routeArea}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.driver}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.teamLeader}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.guard1}
                </td>

                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.guard2}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.8rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.teamNationalityCount}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(FieldStaffDailyRosterGrid);
